export const AUTOCOMPLETE_FULFILLED = 'AUTOCOMPLETE_FULFILLED';
export const AUTOCOMPLETE_FAILED = 'AUTOCOMPLETE_FAILED';
